export const SCHEMA_VERSION = 6;

export const MIGRATIONS: string[] = [
  `
  CREATE TABLE IF NOT EXISTS meta (
    key TEXT PRIMARY KEY,
    value TEXT NOT NULL
  );

  CREATE TABLE IF NOT EXISTS ping (
    id TEXT PRIMARY KEY,
    ts_ms INTEGER NOT NULL,
    type TEXT NOT NULL,
    note TEXT NULL,
    tz_offset_min INTEGER NOT NULL,
    created_at_ms INTEGER NOT NULL
  );
  CREATE INDEX IF NOT EXISTS idx_ping_ts ON ping(ts_ms);
  CREATE INDEX IF NOT EXISTS idx_ping_type_ts ON ping(type, ts_ms);

  CREATE TABLE IF NOT EXISTS rescue_session (
    id TEXT PRIMARY KEY,
    ping_id TEXT NULL REFERENCES ping(id) ON DELETE SET NULL,
    ts_start_ms INTEGER NOT NULL,
    ts_end_ms INTEGER NULL,
    kind TEXT NOT NULL,
    duration_s INTEGER NOT NULL,
    completed INTEGER NOT NULL,
    note TEXT NULL,
    tz_offset_min INTEGER NOT NULL
  );
  CREATE INDEX IF NOT EXISTS idx_rescue_start ON rescue_session(ts_start_ms);
  CREATE INDEX IF NOT EXISTS idx_rescue_ping ON rescue_session(ping_id);

  CREATE TABLE IF NOT EXISTS app_session (
    id TEXT PRIMARY KEY,
    ts_start_ms INTEGER NOT NULL,
    ts_end_ms INTEGER NULL,
    platform TEXT NOT NULL,
    app_version TEXT NOT NULL
  );

  CREATE TABLE IF NOT EXISTS idle_segment (
    id TEXT PRIMARY KEY,
    ts_start_ms INTEGER NOT NULL,
    ts_end_ms INTEGER NOT NULL,
    source TEXT NOT NULL
  );
  `
  ,
  `
  ALTER TABLE ping ADD COLUMN interruption_source TEXT NULL;
  ALTER TABLE rescue_session ADD COLUMN tiny_win TEXT NULL;
  CREATE INDEX IF NOT EXISTS idx_ping_interruption_ts ON ping(interruption_source, ts_ms);
  `,
  `
  ALTER TABLE ping ADD COLUMN subtype TEXT NULL;
  ALTER TABLE rescue_session ADD COLUMN prep_phone_silenced INTEGER NULL;
  ALTER TABLE rescue_session ADD COLUMN prep_tabs_closed INTEGER NULL;
  ALTER TABLE rescue_session ADD COLUMN prep_doc_open INTEGER NULL;
  ALTER TABLE rescue_session ADD COLUMN prep_timer_visible INTEGER NULL;
  CREATE INDEX IF NOT EXISTS idx_ping_subtype_ts ON ping(subtype, ts_ms);
  `,
  `
  CREATE TABLE IF NOT EXISTS rescue_script (
    kind TEXT PRIMARY KEY,
    script TEXT NOT NULL
  );

  CREATE TABLE IF NOT EXISTS parking_lot (
    id TEXT PRIMARY KEY,
    ts_ms INTEGER NOT NULL,
    text TEXT NOT NULL,
    ping_id TEXT NULL REFERENCES ping(id) ON DELETE SET NULL
  );
  CREATE INDEX IF NOT EXISTS idx_parking_ts ON parking_lot(ts_ms);
  `,
  `
  ALTER TABLE ping ADD COLUMN friction_started_ms INTEGER NULL;
  CREATE INDEX IF NOT EXISTS idx_ping_friction_started_ts ON ping(friction_started_ms, ts_ms);
  `,
  `
  ALTER TABLE rescue_session ADD COLUMN outcome TEXT NULL;
  `
];
